<template>
  <div class="el-section">
    <div class="el-section-header">
      <h3 class="el-section-title">{{ticketTitle}}</h3>
    </div>
    <div class="el-section-content">
      <el-form class="jc-datashow-list jc-datashow-list-inline"
               v-if="ticketInfo">
        <el-form-item v-for="(ticket,index) in ticketInfoCopy"
                      class="minLength"
                      :key="index"
                      :title="ticket.value"
                      :label="ticket.label + '：'">
          <p class="overFlow">{{ticket.value | maybeEmpty}}</p>
        </el-form-item>
        <el-form-item v-if="attachInfoCopy != null"
                      class="minLength"
                      :label="$t('text.enclosure') + '：'">
          <p v-if="attachInfoCopy.name !== '' || attachInfoCopy.url !== ''"
             class="minLength">
            <a :href="attachInfoCopy.url"
               target="_self"
               class="overFlow-a"
               :title="$t('ticket.clickDownload')">{{attachInfoCopy.name}}</a></p>
          <div v-else>--</div>
        </el-form-item>
      </el-form>
      <div v-if="finishInfoCopy != null">
        <div v-if="finishInfo.finishRemarks !== ''"
             class="nomal-wrap">{{finishInfo.finishRemarks}}</div>
        <p v-for="(attach) in finishInfoCopy.finishAttach"
           :key="attach.attachName"><a :href="attach.attachPath"
             target="_self"
             :title="$t('ticket.clickDownload')">{{attach.attachName}}</a></p>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>

import { cloneDeep } from 'lodash';

export default {
  props: {
    // info
    ticketInfo: {
      type: Array,
      default () { return []; },
    },
    // attach
    attachInfo: {
      type: Object,
      default () { return null; },
    },
    // header
    ticketTitle: {
      type: String,
      default: ''
    },
    // result
    finishInfo: {
      type: Object,
      default () { return null; },
    }
  },
  computed: {
    ticketInfoCopy () {
      return cloneDeep(this.ticketInfo);
    },
    attachInfoCopy () {
      if (this.attachInfo === null) return null;
      return cloneDeep(this.attachInfo);
    },
    finishInfoCopy () {
      if (this.finishInfo === null) return null;
      return cloneDeep(this.finishInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.overFlow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
a.overFlow-a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inherit;
}
.minLength /deep/ .el-form-item__content {
  width: calc(100% - 60px);
}
.nomal-wrap {
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/TicketInfo.vue